export default "__VITE_ASSET__HNBPp81l__"